import { FC } from 'react';

import { useMyFolders } from '../context/MyFolders';
import RootFoldersView from './RootFoldersView';
import InsideFolderView from './InsideFolderView';

const MyFoldersBody: FC = () => {
  const { data } = useMyFolders();

  return data.currentFolder ? <InsideFolderView /> : <RootFoldersView />;
};

export default MyFoldersBody;
